// extracted by mini-css-extract-plugin
export default {"wrapper":"Ip-z","response":"Jp-z","error":"Kp-z","disabled":"Lp-z","buttons":"Mp-z","feedbackQuestionSection":"Np-z","yesNoWrapper":"Op-z"};